import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { TOKEN_NOT_VALID } from '../common.constants';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private authService: AuthService) {
  }

  intercept(req: HttpRequest<any>,
            next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.url.includes(environment.apiUrls.auth)) {
      // Login or Refresh request
      return next.handle(req);
    }
    const isApiUrl = req.url.startsWith(environment.privateApi) || req.url.startsWith(environment.publicApi);
    if (isApiUrl) {
      req = this.injectToken(req);
    }

    return next.handle(req).pipe(catchError(error => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        if (error.error.code === TOKEN_NOT_VALID) {
          this.authService.clearCurrentUser(true);
          return throwError(error);
        } else {
          return this.handle401Error(req, next);
        }
      } else {
        return throwError(error);
      }
    }));
  }

  injectToken(request: HttpRequest<any>) {
    const token = this.authService.user$.getValue()?.token;
    return !token ? request : request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.authService.refreshToken().pipe(
        switchMap(() => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(true);
          return next.handle(this.injectToken(request));
        }));

    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(() => {
          return next.handle(this.injectToken(request));
        }));
    }
  }
}
